export default {
    question: null,
    answers: [],
}